import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 5B344682-C177-40CC-97EC-418D010EAE07
 * name stairs-down
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/stairs-down.svg
 * tags
 * - Transportation + Other 
 */
export const StairsDownIcon = createSvgIcon(<><path d="M15 6H22V9H18V13H14V17H10V21H3V18H7V14H11V10H15V6M4.83 8.34L10.34 2.83L12.17 4.66L6.66 10.17L8.5 12H3V6.5L4.83 8.34Z" /></>, 'StairsDownIcon');
export default StairsDownIcon